export default "__VITE_ASSET__Dod3jGmo__"